import { Input } from "antd";

import FormButton from "../FormButton";
import {
  ModalContainer,
  Button,
  XButton,
  XButtonContainer,
  ButtonContainer,
  Title,
  Description,
} from "./styles";
import { useState } from "react";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    zIndex: 999999,
    backgroundColor: "rgba(201, 201, 201, 0.5)",
  },
};

function ConfirmationModal({
  modalIsOpen,
  setIsOpen,
  confirmationFunction,
  cancelationFunction,
  confirmationText,
  cancelText,
  title,
  description,
  isLoading,
  withInput = false,
  inputPlaceholder,
  InputIsObrigatory = false,
}) {
  const [inputValue, setInputValue] = useState("");

  function closeModal() {
    if (cancelationFunction) {
      cancelationFunction();
    }
    setInputValue("");
    setIsOpen(false);
  }

  function handleConfirmation() {
    if (isLoading) {
      return;
    }
    confirmationFunction(inputValue);
    setInputValue("");
  }
  const { TextArea } = Input;

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Confirmação"
      className="Modal"
    >
      {title && <Title>{title}</Title>}
      <Description>{description}</Description>
      {withInput && (
        <>
          <TextArea
            placeholder={inputPlaceholder}
            maxLength={100}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </>
      )}
      <ButtonContainer>
        <Button
          disabled={InputIsObrigatory && inputValue.trim() === ""}
          onClick={() => handleConfirmation()}
          color="#002244"
        >
          {confirmationText}
        </Button>
        {cancelText && (
          <Button
            onClick={() => {
              closeModal();
            }}
            color="#C9C9C9"
          >
            {cancelText}
          </Button>
        )}
      </ButtonContainer>
    </ModalContainer>
  );
}

export default ConfirmationModal;
